import * as yup from 'yup';
import { calcularIdade } from '../../dependentesv2/helpers/funcoesAuxiliares';
import { decriptoLocalStorage } from '../../../modulos/cripotografia/criptoStorage';

const area = decriptoLocalStorage('area');

yup.addMethod(yup.date, 'validaTitular75AnosZB', function (errorMessage) {
    return this.test('test-idade-maior-75', errorMessage, function (_value) {
        try {
            const { path, createError, parent } = this;
            let temErro = false;
            const { Nascimento, SubGrupo } = parent;
            const idadeSetentaCinco = 75;
            const idade = calcularIdade(Nascimento);

            if (SubGrupo?.trim() === 'ZB' && (idade && idade > idadeSetentaCinco)) {
                temErro = true;
            }

            return !temErro || createError({
                path,
                message: errorMessage
            });
        } catch (error) {
            console.log(error);
        }
    });
});

const dataDezoitoAnosAtras = () => {
    const hoje = new Date();
    const anoAtual = hoje.getFullYear();
    const anoOitoAtras = anoAtual - 18;
    
    const dataOitoAnosAtras = new Date(anoOitoAtras, hoje.getMonth(), hoje.getDate());   
    
    return dataOitoAnosAtras;
};

const requireFilial =
    area == 2 ?
        yup.string().required('Nome Escritorio é um campo obrigatório!') :
        yup.string();

export default function validations() {
    return yup.object().shape({
        Nome: yup
            .string()
            .min(3, 'Nome precisa ter mais de 4 caracteres.')
            .required('Nome é um campo obrigatório!'),
        DiaVenc: yup
            .string()
            .max(2, 'Máximo 2 caracter.')
            .required('Dia do Vencimento é um campo obrigatório!'),
        CPF: yup
            .string()
            .transform(value => value.replace(/[^\d]/g, ''))
            .max(11, 'Cpf precisa ter 11 caracteres')
            .min(11, 'Cpf precisa ter 11 caracteres')
            .required('CPF é um campo obrigatorio!')
            .cpf(''),
        Nascimento: yup
            .date(new Date() , 'Datas não pode ser maior que a atual.')
            .max(dataDezoitoAnosAtras(), 'Titular não pode ter menos que 18 anos de idade.' )            
            .required('Nascimento é um campo obrigatório!')
            .validaTitular75AnosZB('No plano ZELO BÁSICO o titular não pode ser maior que 75 anos.'),
        CEPResid: yup
            .string()
            .min(8, 'CEP precisa ter 8 caracteres.')
            .required('CEP é um campo obrigatório!'),
        numeroResidencia: yup.string().required('Número é obrigatório!'),
        AssReferenciaEndereco: yup
            .string()
            .max(70, 'Máximo 70 caracteres.')
            .notRequired(),
        AssEmail: yup
            .string()
            .email('Email não é válido')
            .required('Email é obrigatório')
            .test(
                '',
                '@grupozelo.com não é um domínio permitido!',
                (value, context) => !(value && value.toLowerCase().includes('@grupozelo'))
            ),
        Sexo: yup
            .string()
            .min(5, 'Sexo precisa ter mais de 4 caracteres.')
            .required('Sexo é um campo obrigatório!'),
        SubGrupo: yup.string().required('SubGrupo é um campo obrigatório!'),
        Telefone: yup.string().min(10, 'Telefone deve ter 10 caracteres.'),
        Celular: yup
            .string()
            .min(11, 'Celular precisa ter mais de 11 caracteres.')
            .required('Celular é um campo obrigatório!'),
        AssTipoCobranca: yup.string().required('Tipo Cobrança é obrigatório!'),
        RG: yup.string().min(5, 'Mínimo 5 caracteres').max(14, 'Máximo 14 caracteres'),
        TipoVenda: yup.string().required('Tipo de venda é obrigatório!'),
        MaeAssoc: yup.string(),
        idCemiterio: yup.string(),
        Obs1: yup.string().max(20, 'Observação permite no máximo 20 caracteres!'),
        Promocional: yup.boolean(),
        payzentipomensalidade: yup.string().required('Tipo de mensalidade é obrigatório!'),
        Carencia: yup.number().when('Promocional', {
            is: true,
            then: yup
                .number()
                .integer()
                .positive()
                .min(3, 'Carencia é um campo obrigatório')
                .required('Carencia é um campo obrigatório!')
        }),
        ValorDinamico:
            yup.number().when(['SubGrupo', 'TipoVenda'], {
                is: (SubGrupo, TipoVenda) => SubGrupo?.trim() === 'ZTA' && TipoVenda === 'TROCA',
                then: yup
                    .number()
                    .min(0, 'Valor do plano não pode ser negativo!')
                    .required('Valor do plano é um campo obrigatório!'),
                otherwise: yup.number()
            }),
        filialVendedor: requireFilial
    });
} 